import { css } from 'linaria'

const classes = {
  iframe: css`
    height: 100vh;
    width: 100vw;
  `,
}
export default classes
